import React, { useEffect, useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import AnimatedPage from "../components/AnimatedPage";
import Header from "../components/Header";
import Footer from "../components/Footer";

// Danh sách toàn bộ mã sảnh game hiện có trên hệ thống
const PROVIDERS = [
    { code: "4", name: "AG" },
    { code: "79", name: "BBIN" },
    { code: "104", name: "CMD" },
    { code: "16", name: "CQ9" },
    { code: "27", name: "DG" },
    { code: "86", name: "Evolution" },
    { code: "142", name: "FB" },
    { code: "140", name: "JILI" },
    { code: "121", name: "KingMaker" },
    { code: "102", name: "V8 Poker" },
    { code: "123", name: "King Poker" },
    { code: "43", name: "MG" },
    { code: "39", name: "PP" },
    { code: "174", name: "SABA" },
    { code: "54", name: "SBO" },
    { code: "151", name: "UG" },
    { code: "118", name: "WM" },
    { code: "99", name: "TF" },
    { code: "112", name: "SEXY" },
    { code: "111", name: "Playtech" },
    { code: "28", name: "Allbet" },
    { code: "55", name: "JDB" },
    { code: "202", name: "WS168" },
    { code: "61", name: "IMES" },
    { code: "132", name: "SV388" }
];

function TransferGame() {
    const navigate = useNavigate();
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [lobbies, setLobbies] = useState(
        PROVIDERS.map(p => ({ ...p, balance: 0, status: 'loading' }))
    );
    const [isGlobalLoading, setIsGlobalLoading] = useState(false);

    const handleBackClick = () => {
        navigate(-1);
    };

    // Cấu hình Axios Interceptor gửi kèm token
    useEffect(() => {
        const interceptor = axios.interceptors.request.use(
            (config) => {
                const token = localStorage.getItem("user");
                if (token) {
                    config.headers["Authorization"] = `Bearer ${token}`;
                }
                return config;
            },
            (error) => {
                return Promise.reject(error);
            }
        );

        // Quét số dư tất cả sảnh game khi component mount
        fetchAllBalances();

        return () => {
            axios.interceptors.request.eject(interceptor);
        };
    }, []);

    // Khởi tạo ví ngầm
    useEffect(() => {
        if (profile) {
            axios.post(`${process.env.REACT_APP_API_URL}/casino/create`, {}).catch(() => {});
        }
    }, [profile]);

    // Hàm gọi API đồng loạt để lấy số dư tất cả sảnh game
    const fetchAllBalances = async () => {
        setIsGlobalLoading(true);

        // Cập nhật lại số dư ví chính mới nhất
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`)
            .then((res) => {
                if (res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch(() => localStorage.removeItem("user"));

        // Load hiệu ứng cho tất cả các sảnh
        setLobbies(prev => prev.map(l => ({ ...l, status: 'loading' })));

        const fetchBalance = async (lobby) => {
            try {
                const res = await axios.post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { product_type: lobby.code });
                return { ...lobby, balance: res.data.data.balance || 0, status: 'idle' };
            } catch (err) {
                return { ...lobby, balance: 0, status: 'idle' };
            }
        };

        const results = await Promise.all(PROVIDERS.map(l => fetchBalance(l)));
        setLobbies(results);
        setIsGlobalLoading(false);
    };

    // Hàm rút tiền (thu hồi) từ MỘT sảnh
    const handleWithdrawSingle = async (code, amount) => {
        if (amount <= 0) return;

        setLobbies(prev => prev.map(l => l.code === code ? { ...l, status: 'withdrawing' } : l));

        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                product_type: code,
                type: 2, 
                money: Math.floor(amount)
            });

            swal("Thành công", "Rút tiền về ví chính thành công!", "success");
            fetchAllBalances(); 
        } catch (err) {
            swal("Thất bại", err.response?.data?.message || "Đã xảy ra lỗi khi rút tiền", "error");
            setLobbies(prev => prev.map(l => l.code === code ? { ...l, status: 'idle' } : l));
        }
    };

    // Hàm THU HỒI TẤT CẢ CÁC SẢNH CÓ TIỀN
    const handleWithdrawAll = async () => {
        const lobbiesWithBalance = lobbies.filter(l => l.balance > 0);
        
        if (lobbiesWithBalance.length === 0) {
            swal("Thông báo", "Không có sảnh nào đang chứa số dư để thu hồi!", "info");
            return;
        }

        setIsGlobalLoading(true);
        let successCount = 0;

        for (const lobby of lobbiesWithBalance) {
            setLobbies(prev => prev.map(l => l.code === lobby.code ? { ...l, status: 'withdrawing' } : l));
            try {
                await axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                    product_type: lobby.code,
                    type: 2,
                    money: Math.floor(lobby.balance)
                });
                successCount++;
                setLobbies(prev => prev.map(l => l.code === lobby.code ? { ...l, balance: 0, status: 'idle' } : l));
            } catch (err) {
                setLobbies(prev => prev.map(l => l.code === lobby.code ? { ...l, status: 'idle' } : l));
            }
        }

        setIsGlobalLoading(false);
        fetchAllBalances();

        if (successCount === lobbiesWithBalance.length) {
            swal("Thành công", "Đã thu hồi toàn bộ số dư các sảnh về ví chính!", "success");
        } else {
            swal("Hoàn tất", `Đã thu hồi thành công ${successCount}/${lobbiesWithBalance.length} sảnh có tiền.`, "warning");
        }
    };

    return (
        <AnimatedPage>
            <Header profile={profile} />

            <style>{`
                html, body, #root {
                    height: auto !important;
                    min-height: 100vh;
                    overflow-y: auto !important;
                    background-color: #e3e1e2 !important; 
                    margin: 0; padding: 0;
                }
                
                .transfer-wrapper {
                    padding-bottom: 100px;
                    background-color: #e3e1e2;
                    min-height: 100vh;
                }

                /* ================================================== */
                /* 1. THÔNG TIN USER BẰNG BANNER                        */
                /* ================================================== */
                .center-head {
                    width: 100%;
                    height: 180px;
                    background: url('https://dztwieyphe62d.cloudfront.net/content/images/main/user/banner-center.jpg') center top no-repeat;
                    background-size: cover;
                    padding: 0 20px; 
                    display: flex;
                    align-items: center; 
                    color: #fff;
                    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
                }
                .profile-avatar-wrapper { position: relative; margin-right: 15px; flex-shrink: 0; }
                .profile-avatar { width: 65px; height: 65px; background-color: #fff; border-radius: 50%; display: flex; justify-content: center; align-items: center; }
                .profile-avatar i { font-size: 38px; color: #ffca28; }
                .profile-v1-badge { position: absolute; top: -2px; right: -5px; background-color: #ff9800; color: #fff; border-radius: 50%; width: 20px; height: 20px; display: flex; justify-content: center; align-items: center; font-size: 11px; font-weight: bold; border: 2px solid #222; }
                .profile-info { flex: 1; display: flex; flex-direction: column; justify-content: center; text-align: left; }
                .profile-info h3 { margin: 0 0 2px 0; font-size: 16px; font-weight: bold; color: #fff; }
                .profile-stats p { margin: 2px 0; font-size: 13px; color: #fff; }
                .profile-stats span { color: #ff9800; font-weight: bold; }

                /* ================================================== */
                /* 2. TIÊU ĐỀ TRANG VÀ NÚT BACK                       */
                /* ================================================== */
                .page-header-box {
                    display: flex;
                    align-items: center;
                    padding: 15px;
                    background: transparent;
                }
                .back-btn {
                    background: #fff;
                    color: #b71c1c;
                    width: 35px;
                    height: 35px;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                    margin-right: 15px;
                }
                .back-btn:active { background: #f0f0f0; }
                .page-title-h1 {
                    font-size: 18px;
                    font-weight: bold;
                    color: #333;
                    margin: 0;
                    text-transform: uppercase;
                }

                /* ================================================== */
                /* 3. GIAO DIỆN QUÉT SẢNH TỰ ĐỘNG                     */
                /* ================================================== */
                .transfer-content { padding: 0 15px 20px 15px; }

                .transfer-header-box-new {
                    position: relative;
                    text-align: center;
                    margin-bottom: 25px;
                    padding: 15px;
                    background: #fff;
                    border-radius: 8px;
                    box-shadow: 0 2px 6px rgba(0,0,0,0.1);
                }
                .text-red { color: #d32f2f; font-size: 15px; display: block; margin-bottom: 5px; }
                .text-blue { color: #007bff; font-weight: bold; font-size: 20px; display: block; }
                
                .btn-reload-mobile {
                    position: absolute;
                    right: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                    background: #f1f3f5;
                    border: 1px solid #ced4da;
                    color: #495057;
                    padding: 6px 10px;
                    border-radius: 4px;
                    cursor: pointer;
                    font-size: 12px;
                    font-weight: 600;
                    display: flex;
                    align-items: center;
                    gap: 5px;
                    transition: all 0.2s;
                }
                .btn-reload-mobile:hover { background: #e2e6ea; }
                .btn-reload-mobile:disabled { opacity: 0.6; cursor: not-allowed; }

                .btn-orange-gradient {
                    background: linear-gradient(180deg, #f09819 0%, #ed6a22 100%);
                    color: white;
                    border: none;
                    border-radius: 6px;
                    padding: 14px;
                    font-size: 15px;
                    font-weight: bold;
                    width: 100%;
                    cursor: pointer;
                    text-transform: uppercase;
                    margin-bottom: 25px;
                    box-shadow: 0 3px 6px rgba(0,0,0,0.2);
                    transition: opacity 0.2s;
                }
                .btn-orange-gradient:disabled { opacity: 0.6; cursor: not-allowed; box-shadow: none; }

                /* 4 Ô 1 DÒNG RESPONSIVE */
                .lobby-grid {
                    display: grid;
                    grid-template-columns: repeat(4, 1fr);
                    gap: 10px;
                }
                @media (max-width: 380px) {
                    .lobby-grid { grid-template-columns: repeat(3, 1fr); }
                }

                .lobby-card {
                    background: #ffffff;
                    border: 1px solid #e0e0e0;
                    border-radius: 8px;
                    padding: 12px 2px;
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    min-height: 90px;
                    box-shadow: 0 1px 4px rgba(0,0,0,0.05);
                }
                .lobby-title {
                    font-weight: bold;
                    color: #333;
                    font-size: 12px;
                    margin-bottom: 5px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    width: 100%;
                }
                .lobby-amount {
                    font-weight: bold;
                    color: #000;
                    font-size: 13px;
                    margin-bottom: 5px;
                }
                .lobby-amount.has-money { color: #28a745; }
                .lobby-desc {
                    font-size: 11px;
                    color: #9e9e9e;
                }
                .btn-withdraw-small {
                    background: linear-gradient(180deg, #f09819 0%, #ed6a22 100%);
                    color: white;
                    border: none;
                    padding: 5px 10px;
                    border-radius: 4px;
                    font-size: 11px;
                    font-weight: bold;
                    cursor: pointer;
                    margin-top: 5px;
                    width: 85%;
                }
                .btn-withdraw-small:disabled {
                    background: #ccc;
                    cursor: not-allowed;
                }
            `}</style>

            {isGlobalLoading && (
                <div className="loading">
                    <div className="loader"></div>
                </div>
            )}

            <div className="transfer-wrapper">
                
                {/* 1. THÔNG TIN USER (BANNER GIỮ NGUYÊN) */}
                <div className="center-head">
                    <div className="profile-avatar-wrapper">
                        <div className="profile-avatar">
                            <i className="fa-solid fa-user"></i>
                        </div>
                        <span className="profile-v1-badge">v1</span>
                    </div>
                    <div className="profile-info">
                        <h3>{profile?.username || "Tài khoản"}</h3>
                        <div className="profile-stats">
                            <p>Mã mời : <span>{profile?.code || "---"}</span></p>
                            <p>Số dư : <span>{profile?.money ? Math.floor(profile.money / 1000).toLocaleString("vi-VN") : "0"} Điểm</span></p>
                        </div>
                    </div>
                </div>

                {/* 2. TIÊU ĐỀ TRANG & NÚT BACK */}
                <div className="page-header-box">
                    <div className="back-btn" onClick={handleBackClick}>
                        <KeyboardArrowLeftOutlinedIcon />
                    </div>
                    <h1 className="page-title-h1">Thu hồi số dư</h1>
                </div>

                {/* 3. NỘI DUNG QUÉT SẢNH TỰ ĐỘNG */}
                <div className="transfer-content">
                    {profile && (
                        <>
                            {/* Header: Số dư ví chính + Nút làm mới */}
                            <div className="transfer-header-box-new">
                                <span className="text-red">Số dư ví chính:</span>
                                <span className="text-blue">{profile?.money?.toLocaleString("vi-VN")} VNĐ</span>
                                <button 
                                    className="btn-reload-mobile" 
                                    onClick={fetchAllBalances}
                                    disabled={isGlobalLoading}
                                >
                                    ↻ Làm mới
                                </button>
                            </div>

                            {/* Nút THU HỒI TẤT CẢ */}
                            <button 
                                className="btn-orange-gradient"
                                onClick={handleWithdrawAll} 
                                disabled={isGlobalLoading} 
                            >
                                {isGlobalLoading ? "ĐANG XỬ LÝ..." : "THU HỒI TẤT CẢ VỀ VÍ CHÍNH"}
                            </button>

                            {/* DANH SÁCH SẢNH GAME (4 Ô 1 DÒNG) */}
                            <div className="lobby-grid">
                                {lobbies.map(lobby => (
                                    <div key={lobby.code} className="lobby-card">
                                        <div className="lobby-title">{lobby.name}</div>
                                        
                                        {lobby.status === 'loading' ? (
                                            <div className="lobby-desc">Đang tải...</div>
                                        ) : (
                                            <>
                                                <div className={`lobby-amount ${lobby.balance > 0 ? 'has-money' : ''}`}>
                                                    {lobby.balance > 0 ? Math.floor(lobby.balance).toLocaleString("vi-VN") : "0"}
                                                </div>
                                                
                                                {lobby.balance > 0 ? (
                                                    <button 
                                                        className="btn-withdraw-small"
                                                        onClick={() => handleWithdrawSingle(lobby.code, lobby.balance)}
                                                        disabled={lobby.status !== 'idle' || isGlobalLoading}
                                                    >
                                                        {lobby.status === 'withdrawing' ? "..." : "Rút"}
                                                    </button>
                                                ) : (
                                                    <div className="lobby-desc">Không có số dư</div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
            </div>

            <Footer />
        </AnimatedPage>
    );
}

export default TransferGame;